<template>
    <div class="box_M">
        <div class="info_box_m detail_consultDetail">
            <h1>{{detailContent.title}}</h1>
            <div class="content">
                <div class="line">
                    <div class="tit">
                        <h2>咨询信息</h2>
                        <div class="date"><span>咨询日期:</span>{{detailContent.date}}</div>
                    </div>
                    <div class="desc" v-html="detailContent.content"></div>
                </div>
                <div class="line">
                    <div class="tit">
                        <h2>回复信息</h2>
                        <div class="date"><span>回复日期:</span>{{detailContent.replyTime}}</div>
                    </div>
                    <div class="desc" v-html="detailContent.replyContent"></div>
                </div>                    
            </div>
        </div>

        <bottom-menu></bottom-menu>
    </div>
</template>

<script>
import BottomMenu from '@/components/mobile/BottomMenu.vue'
import { getConsultDetail } from '@/service/api.js'
import { dateFormat } from '@/utils/util.js'

export default {
    components: { BottomMenu },
    data() {
        return {
            detailContent:{
                title:'',
                content:'',
                date:'',
                files:[]
            },
        }
    },
    beforeCreate () {
        getConsultDetail('?consultAskId='+this.$route.params.id).then(data=>{
            console.log(data);
            if (data.code !== 0) {
                this.$toast(data.msg)
            }else{
                this.detailContent.title = data.data.title;
                this.detailContent.date = dateFormat(data.data.questionTime,'Y年M月D日');
                this.detailContent.content = data.data.content;
                this.detailContent.replyContent = data.data.replyRespVO.replyContent
                this.detailContent.replyTime = dateFormat(data.data.replyRespVO.replyTime,'Y年M月D日');
            }
        });
    },
}

</script>
